<div class="cards">
  <div class="card" cdkDrag>
    <div class="card-header" cdkDragHandle>
      <!-- <span class="dragHandle" cdkDragHandle>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </span> -->
      <div class="action-btn">
        <div
          class="dropup"
          [class]="sticky.includes('menu') ? 'is-visible' : ''"
          data-cy="menu"
        >
          <span class="btn btn-sm" (click)="toggleStick('menu')">
            <i class="icon-horizontal-ellipsis"></i>
            <span
              *ngIf="notifications?.length > 0"
              class="badge badge-pill badge-danger"
              style="position: absolute; top: 1em; left: 2em"
              >&nbsp;</span
            >
          </span>
          <div class="dropup-content">
            <app-menu-list [notifications]="notifications"></app-menu-list>
          </div>
        </div>
        <!-- <div class="dropup" [class]="sticky.includes('project') ? 'is-visible' : ''">
          <span class="btn btn-sm" (click)="toggleStick('project')">
            <i class="icon-projects"></i>
          </span>
          <div class="dropup-content">
            <app-project-list></app-project-list>
          </div>
        </div> -->
        <!-- <div class="dropup" [class]="sticky.includes('widget') ? 'is-visible' : ''">
          <span class="btn btn-sm" (click)="toggleStick('widget')">
            <i class="icon-widgets"></i>
          </span>
          <div class="dropup-content">
            <app-widget-list></app-widget-list>
          </div>
        </div> -->
        <div
          class="dropup"
          [class]="sticky.includes('project') ? 'is-visible' : ''"
          data-cy="search"
        >
          <span
            class="btn btn-sm"
            (click)="toggleStick('project'); onIconClicked('project')"
          >
            <i class="icon-search"></i>
          </span>
          <div class="dropup-content">
            <app-search-list></app-search-list>
          </div>
        </div>
        <div
          class="dropup"
          [class]="sticky.includes('layer') ? 'is-visible' : ''"
          data-cy="layer"
        >
          <span class="btn btn-sm" (click)="toggleStick('layer')">
            <i class="icon-layers"></i>
          </span>
          <div class="dropup-content">
            <app-layer-list></app-layer-list>
          </div>
        </div>
        <div
          class="dropup"
          [class]="sticky.includes('toolkit') ? 'is-visible' : ''"
          data-cy="tool"
        >
          <span
            class="btn btn-sm"
            (click)="toggleStick('toolkit')"
            [class.disabled]="
              !(permissions && permissions['create:any.annotation'])
            "
            data-cy="toolkitMenu"
          >
            <i class="icon-toolkit"></i>
          </span>
          <div
            *ngIf="permissions && permissions['create:any.annotation']"
            class="dropup-content"
          >
            <app-toolkit-list></app-toolkit-list>
          </div>
        </div>
        <div
          class="dropup"
          [class]="sticky.includes('action') ? 'is-visible' : ''"
          data-cy="action"
        >
          <span class="btn btn-sm" (click)="toggleStick('action')">
            <i class="icon-actions"></i>
          </span>
          <div class="dropup-content">
            <app-action-list
              (onTimelineToggled)="toggleTimeline($event)"
            ></app-action-list>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" cdkDragHandle>
      <app-widget-one [data]="severityData"></app-widget-one>
    </div>
  </div>

  <div class="card" cdkDrag *ngIf="!isTimeline && currLoc?.ctqrs_enabled">
    <div class="card-header">
      <h5
        class="ctqrs-header"
        [routerLink]="['/location-task-charts', this.currLoc?.id, 'cost']"
      >
        {{ "Cost" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span
        ><span>{{ ctqrs_widget_data?.cost || 0 }}%</span>
      </div>
    </div>
  </div>
  <div class="card" cdkDrag *ngIf="!isTimeline && currLoc?.ctqrs_enabled">
    <div class="card-header">
      <h5
        class="ctqrs-header"
        [routerLink]="['/location-task-charts', this.currLoc?.id, 'time']"
      >
        {{ "Time" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Planned</span
        ><span>{{ ctqrs_widget_data?.time.planned || 0 }}%</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span
        ><span>{{ ctqrs_widget_data?.time.actual || 0 }}%</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Delta</span
        ><span>{{ ctqrs_widget_data?.time.delta || 0 }}%</span>
      </div>
    </div>
  </div>
  <div class="card" cdkDrag *ngIf="!isTimeline && currLoc?.ctqrs_enabled">
    <div class="card-header">
      <h5
        class="ctqrs-header"
        [routerLink]="['/location-task-charts', this.currLoc?.id, 'resource']"
      >
        {{ "Resource" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span
        ><span>{{ ctqrs_widget_data?.resource || 0 }}%</span>
      </div>
    </div>
  </div>
  <div class="card" cdkDrag *ngIf="!isTimeline && currLoc?.ctqrs_enabled">
    <div class="card-header">
      <h5
        class="ctqrs-header"
        [routerLink]="['/location-task-charts', this.currLoc?.id, 'safety']"
      >
        {{ "Safety" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">LTI</span
        ><span>{{ ctqrs_widget_data?.safety.LTI || 0 }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">ZETO</span
        ><span>{{ ctqrs_widget_data?.safety.ZETO || 0 }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Minor Injury</span
        ><span>{{ ctqrs_widget_data?.safety.minor || 0 }}</span>
      </div>
    </div>
  </div>
  <div class="card" cdkDrag *ngIf="!isTimeline && currLoc?.ctqrs_enabled">
    <div class="card-header">
      <h5
        class="ctqrs-header"
        [routerLink]="['/location-task-charts', this.currLoc?.id, 'quality']"
      >
        {{ "Quality" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Issues</span
        ><span>{{ ctqrs_widget_data?.quality.issues || 0 }}</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Rectified</span
        ><span>{{ ctqrs_widget_data?.quality.rectified || 0 }}</span>
      </div>
    </div>
  </div>

  <!-- <div *ngIf="currLoc?.id;else home_ctqrs"></div> -->

  <div class="timeline rounded d-flex" *ngIf="isTimeline" cdkDrag>
    <div class="d-flex flex-column justify-content-end align-items-end">
      <!-- <p class="ortho-label text-muted mr-1 my-1">thermal</p>
      <p class="ortho-label text-muted mr-1 my-1">thermal</p>
      <p class="ortho-label text-muted mr-1 my-1">thermal</p>
      <p class="ortho-label text-muted mr-1 my-1">ortho</p> -->
      <a class="btn btn-sm btn-prev btn-light"
        ><i class="icon-arrow-left"></i
      ></a>
    </div>
    <div class="time-scroll">
      <div class="layer-dot-container" *ngFor="let ml of map_layers; trackById">
        <a
          class="btn btn-sm btn-circle btn-light my-1 btn-tool"
          *ngFor="let layer of ml.map_layers; trackById"
          (click)="attachMapLayer(layer)"
        >
          <ng-container [ngSwitch]="layer.layer_type">
            <i *ngSwitchCase="'thermal'" class="icon-thermal"></i>
            <i *ngSwitchCase="'3d' || '3d-mesh'" class="icon-d-mesh"></i>
            <i *ngSwitchCase="'embed'" class="icon-annotation-box-2"></i>
            <i *ngSwitchCase="'geojson'" class="icon-annotation-box-2"></i>
            <i *ngSwitchDefault class="icon-ortho"></i>
          </ng-container>
          <span
            class="tooltip-text"
            style="margin-top: -2.7em; margin-left: -3.5em"
            >{{ layer.layer_type | titlecase }}: {{ layer.layer_name }}</span
          >
        </a>
        <div class="date bg-light text-muted">
          {{ ml.date | date: "dd/MM/yyyy" }}
        </div>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-end">
      <a class="btn btn-sm btn-next btn-light"
        ><i class="icon-arrow-right"></i
      ></a>
    </div>
  </div>
</div>

<ng-template #home_ctqrs>
  <div class="card">
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Projects" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Live (Ongoing)</span><span>5</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Completed</span><span>2</span>
      </div>
    </div>
  </div>
  <div class="card" cdkDrag>
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Cost" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span><span>5</span>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Time" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Planned</span><span>100%</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span><span>57%</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Delta</span><span>-43%</span>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Resource" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Actual</span><span>65%</span>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Safety" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">LTI</span><span>0</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">ZETO</span><span>7</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Minor Injury</span><span>10</span>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h5 class="ctqrs-header">
        {{ "Quality" | translate }}
      </h5>
    </div>
    <div class="card-body ctqrs">
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Issues</span><span>25</span>
      </div>
      <div class="d-flex justify-content-between">
        <span class="font-weight-bold">Rectified</span><span>19</span>
      </div>
    </div>
  </div>
</ng-template>
